import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DesignCorrespondencesHandoverContent from '../content/designCorrespondencesHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class DesignCorrespondencesHandover extends React.Component {
	static getTitle() {
		return 'Design Correspondence';
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<DesignCorrespondencesHandoverContent report={report} />
		);
	}
}

DesignCorrespondencesHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	DesignCorrespondencesHandover, {
		title: 'Design Correspondence',
		className: 'design-correspondences-handover'
	})
);
